module.exports = __webpack_public_path__ + "img/jelly.fec63932.png";